import './scenario-selector.css';

/**
 * Single scenario switch (Pessimista / Moderado / Otimista). Selecting a
 * scenario drives every result card in the plan — the whole "six questions",
 * executive summary, financials, deck and PDF derive from the active scenario.
 */
export function ScenarioSelector({ scenarios, active, onChange, label = 'CENÁRIO', className = '' }) {
  if (!scenarios || !scenarios.length) return null;
  return (
    <div className={`scenario-selector ${className}`} data-testid="scenario-selector">
      {label && <span className="scenario-selector-label">{label}</span>}
      <div className="scenario-selector-track" role="tablist" aria-label="Cenário do plano">
        {scenarios.map((s) => {
          const selected = active === s.key;
          return (
            <button
              key={s.key}
              type="button"
              role="tab"
              aria-selected={selected}
              className={`scenario-selector-btn ${selected ? 'selected' : ''}`}
              data-testid={`scenario-selector-${s.key}`}
              onClick={() => onChange(s.key)}
              style={selected ? { '--sc-color': s.color || '#0f766e' } : undefined}
              title={s.description || s.label}
            >
              <span className="scenario-selector-dot" style={{ background: s.color || '#334155' }} aria-hidden="true" />
              {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
